import supabase from "../../supabase-client";

// What a traslado owes its trasladista(s) that no settlement covers yet — the
// same preview TrasladoSettlementCard shows; the real amounts are computed by
// create_traslado_settlement. The first settlement is the anticipo (chofer +
// comida, split with the secondary trasladista); later ones pay approved tickets.
export const PAYABLE = ["authorized", "in_progress", "completed", "settled"];

export function toSettle(order) {
  const live = (order.settlements || []).filter((s) => s.status !== "cancelled");
  const first = live.length === 0;
  const second = first && order.trasladista_secondary ? Number(order.secondary_amount || 0) : 0;
  const chofer = first ? Number(order.driver_extra || 0) - second : 0;
  const comida = first ? Number(order.estimate?.comida || 0) : 0;
  const tickets = (order.tickets || []).filter((t) => t.status === "approved" && !t.settlement_id);
  const ticketsTotal = tickets.reduce((a, t) => a + Number(t.total || 0), 0);
  return { first, chofer, second, comida, tickets, ticketsTotal, total: chofer + second + comida + ticketsTotal };
}

export const ORDER_SELECT =
  "id, status, driver_extra, estimate, secondary_amount, trasladista_secondary, origin_label, dest_label, " +
  "car(plate, model(name)), " +
  "trasladista:trasladistas!traslado_orders_trasladista_fkey(name), " +
  "secondary:trasladistas!traslado_orders_trasladista_secondary_fkey(name), " +
  "tickets:traslado_tickets!traslado_tickets_traslado_order_fkey(id, kind, status, settlement_id, merchant_name, ticket_date, total, deductible, photo_path), " +
  "settlements:traslado_settlements!traslado_settlements_traslado_order_fkey(status)";

export async function loadToSettle() {
  const { data, error } = await supabase.from("traslado_orders").select(ORDER_SELECT).in("status", PAYABLE).order("id");
  if (error) return { error };
  return { rows: (data || []).map((o) => ({ ...o, owed: toSettle(o) })).filter((o) => o.owed.total > 0) };
}
